module.exports = __webpack_public_path__ + "static/ia-b3efc9645f2643a322a62b209232587f.png";